import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '../reducer'

const sessionStateSelector = (state: AppState) => state.session

export const getSessionIdSelector = createSelector(sessionStateSelector, sessionState => sessionState.sessionId)
